/* Testimonials from Ask Brill → Testimonials. Two ways in, one row shape.
 *
 * QUICK: she picks stars and writes her own words.
 * BRILL WRITES IT: Brill asks two questions, drafts, and ends with a
 * `<<<TESTIMONIAL_SUBMITTED>>>` block (api/_lib/prompts.js). Until 2026-10-23
 * that block saved straight away as FIVE STARS she never chose. Now it waits in
 * a card for her rating, and nothing saves without one — `testimonialRow`
 * refuses a row with no stars, so neither path can fill them in for her.
 */

/* Brill's finished testimonial, or null when this reply has none. */
export function parseTestimonialBlock(reply) {
  const m = String(reply || "").match(/<<<TESTIMONIAL_SUBMITTED>>>([\s\S]*?)<<<TESTIMONIAL_END>>>/);
  if (!m) return null;
  const block = m[1];
  const field = (re) => (block.match(re)?.[1] || "").trim();
  const quote = field(/QUOTE:([\s\S]*?)(?=\nATTRIBUTION:|$)/);
  if (!quote) return null;
  return {
    quote,
    attribution: field(/ATTRIBUTION:([\s\S]*?)(?=\nVIDEO:|$)/),
    video: field(/VIDEO:([\s\S]*?)$/),
  };
}

const validStars = (n) => Number.isInteger(n) && n >= 1 && n <= 5;

/* The `testimonials` row for either path, or null without a real rating.
   Stars are carried in the column AND the JSON, so the list she sees after a
   reload shows them (it used to read only the JSON, which Brill's path never
   wrote). `type` is what Admin labels it by: quick_review / chat_review. */
export function testimonialRow({ userId, stars, quote = "", attribution = "", video = "", type }) {
  if (!userId || !validStars(stars)) return null;
  return {
    clerk_user_id: userId,
    trigger: "chat_review",
    stars,
    response: JSON.stringify(type === "chat_review"
      ? { type, quote, attribution, video, stars }
      : { type: "quick_review", quote, stars }),
  };
}

/* One saved row → what her list shows. The stars COLUMN wins: older Brill-
   written rows have them only there. */
export function submissionOf(row) {
  let p = {};
  try { p = JSON.parse(row.response) || {}; } catch { p = { quote: row.response }; }
  return {
    id: row.id,
    quote: p.quote || (typeof row.response === "string" && !row.response.startsWith("{") ? row.response : ""),
    attribution: p.attribution || "",
    video: p.video || "",
    stars: validStars(row.stars) ? row.stars : (validStars(p.stars) ? p.stars : null),
    created_at: row.created_at,
  };
}
